import { Flex, Text } from '@chakra-ui/react';
import { faBars } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  ButtonText,
  Menu,
  MenuButton,
  MenuItem,
  MenuList
} from '@morressier/alembic';
import { TemplateCategoryDoc } from '@publishing-engine/domain/models/email-templates';

const EmailActionMenu = ({
  templateId,
  category,
  isConfigurable,
  isDefault,
  handleClick,
  handleDeleteClick,
  handleCategoryClick,
  onValidateDefaultTemplate
}: {
  templateId?: string;
  category?: TemplateCategoryDoc;
  isConfigurable?: boolean;
  isDefault?: boolean;
  handleCategoryClick?: (catogery: TemplateCategoryDoc) => void;
  handleClick?: (templateId: string, isClone?: boolean) => void;
  handleDeleteClick?: (templateId: string) => void;
  onValidateDefaultTemplate?: () => void;
}) => {
  return (
    <Menu ariaLabel="normal menu">
      <MenuButton>
        <ButtonText>
          <Flex gap={2} alignItems="center">
            <FontAwesomeIcon size="lg" icon={faBars} />
          </Flex>
        </ButtonText>
      </MenuButton>

      {templateId && handleClick && (
        <MenuList>
          {isConfigurable && !isDefault && (
            <MenuItem
              ariaLabel={'Default Template'}
              onClick={() => onValidateDefaultTemplate?.()}
            >
              <Text textStyle="context">Make as Default</Text>
            </MenuItem>
          )}
          <MenuItem
            ariaLabel={'View Template'}
            onClick={() => handleClick(templateId)}
          >
            <Text textStyle="context">Edit Template</Text>
          </MenuItem>
          <MenuItem
            ariaLabel="Clone Template"
            onClick={() => handleClick(templateId, true)}
          >
            <Text textStyle="context">Copy as a New Template</Text>
          </MenuItem>
          <MenuItem
            ariaLabel="Delete Template"
            onClick={() => handleDeleteClick?.(templateId)}
          >
            <Text textStyle="context" color="actionSecondaryCautionContent">
              Delete Template
            </Text>
          </MenuItem>
        </MenuList>
      )}
      {category && handleCategoryClick && (
        <MenuList>
          <MenuItem
            ariaLabel={'Edit Category'}
            onClick={() => handleCategoryClick(category)}
          >
            <Text textStyle="context">Edit Email Tag</Text>
          </MenuItem>
        </MenuList>
      )}
    </Menu>
  );
};

export default EmailActionMenu;
